import React, { type ReactNode } from "react";
import styles from "./styles.module.scss";
import { Header } from "../header/Header";
import { Footer } from "../footer/Footer";
import Line from "../../../assets/images/line.png";

export interface JournalPageProps {
  leftContent: ReactNode;
  rightContent: ReactNode;
  scrollToRef: (ref: React.RefObject<HTMLElement>) => void;
  aboutRef: React.RefObject<HTMLElement>;
  mainRef: React.RefObject<HTMLElement>;
  featuresRef: React.RefObject<HTMLElement>;
  contactsRef: React.RefObject<HTMLElement>;
  activeSection: string;
}

export const JournalPage: React.FC<JournalPageProps> = ({
  leftContent,
  rightContent,
  scrollToRef,
  aboutRef,
  mainRef,
  featuresRef,
  contactsRef,
  activeSection,
}) => {
  return (
    <div className={styles.journalPage}>
      <div className={styles.left}>
        <Header
          fullWidth={false}
          scrollToRef={scrollToRef}
          aboutRef={aboutRef}
          mainRef={mainRef}
          featuresRef={featuresRef}
          contactsRef={contactsRef}
          activeSection={activeSection}
        />
        {leftContent}
      </div>
      <img src={Line} className={styles.line} alt="" />
      <div className={styles.right}>
        {rightContent}
        <Footer />
      </div>
    </div>
  );
};
